import dynamicSort from "./dynamicSort";

const orderByPostDate = (array, order) => array.sort(dynamicSort(order));
// order can be desc or asc

export default orderByPostDate;
